import { render, staticRenderFns } from "./InputBase.vue?vue&type=template&id=4ec4bbd8&scoped=true"
import script from "./InputBase.vue?vue&type=script&lang=js"
export * from "./InputBase.vue?vue&type=script&lang=js"
import style0 from "./InputBase.vue?vue&type=style&index=0&id=4ec4bbd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4bbd8",
  null
  
)

/* custom blocks */
import block0 from "./InputBase.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports